import { render, staticRenderFns } from "./breeder-sidebar.vue?vue&type=template&id=34042ae5&scoped=true&lang=pug"
import script from "./breeder-sidebar.js?vue&type=script&lang=js&external"
export * from "./breeder-sidebar.js?vue&type=script&lang=js&external"
import style0 from "./breeder-sidebar.vue?vue&type=style&index=0&id=34042ae5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34042ae5",
  null
  
)

export default component.exports